import { useEffect, useState } from "react";
import pages from "../constants/pages";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { signInMember } from "../redux/slices/memberSlice";
import useAxios from "./useAxios";

function useAuthRedirect() {
  const axios = useAxios();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [authStatus, setAuthStatus] = useState({
    isLoading: true,
    isComplete: false,
    error: null,
  });

  useEffect(() => {
    // At the top of your destination page
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("clearStorage") === "true") {
      localStorage.clear();
      sessionStorage.clear(); // Optional: also clear sessionStorage
    }

    const authenticateUser = async () => {
      try {
        setAuthStatus({ isLoading: true, isComplete: false, error: null });

        const queryParams = new URLSearchParams(location.search);
        const uuid = queryParams.get("uuid");

        let popup, isLoginOTP, visitorID, visitor_id, mobileNo;
        const isLoginPage = location.pathname.includes("/sign-in");

        // If UUID exists, fetch details from API
        if (uuid) {
          try {
            const uuidResponse = await axios({
              url: `notification/otp/details?uuid=${uuid}`,
              method: "GET",
              disableRedirect: true,
              disableError: true,
            });
            console.log("UUID Response:");
            console.log(uuidResponse.data?.data);

            // Extract values from the API response
            if (uuidResponse.status) {
              popup = uuidResponse.data?.data.popup;
              isLoginOTP = uuidResponse.data?.data.login_otp;
              visitorID = uuidResponse.data?.data.visitorId;
              visitor_id = uuidResponse.data?.data.visitor_id;
              mobileNo = uuidResponse.data?.data.mobile_no;
            }
          } catch (uuidError) {
            console.error("Error fetching UUID details:", uuidError);
            setAuthStatus({
              isLoading: false,
              isComplete: false,
              error: "Failed to fetch notification details",
            });
            return;
          }
        } else {
          // If no UUID, get values from query params as before
          popup = queryParams.get("popup");
          isLoginOTP = queryParams.get("login_otp");
          visitorID = queryParams.get("visitorId");
          visitor_id = queryParams.get("visitor_id");
          mobileNo = queryParams.get("mobile_no");
        }

        if (
          isLoginOTP &&
          mobileNo &&
          localStorage.getItem("visitorDataID") != (visitor_id || visitorID)
        ) {
          // sessionStorage.clear();
          // localStorage.clear();
        }

        const token =
          sessionStorage.getItem("auth_token_with_guard") ||
          localStorage.getItem("auth_token_with_guard") ||
          sessionStorage.getItem("authToken") ||
          localStorage.getItem("authToken");

        if (isLoginOTP && mobileNo) {
          const response = await axios({
            url: `event/booking/verify-otp?mobile_no=${mobileNo}&otp=${isLoginOTP}&is_mobile_number_required=false`,
            method: "POST",
            disableRedirect: true,
          });

          if (response.status) {
            await dispatch(
              signInMember({
                authToken: response.data.auth_token,
                ID: response.data._id,
              })
            );
            localStorage.setItem("mobileNumber", "91" + mobileNo);
            setAuthStatus({ isLoading: false, isComplete: true, error: null });
          } else {
            setAuthStatus({
              isLoading: false,
              isComplete: false,
              error: "Authentication failed",
            });
            navigate("/error");
          }
        } else if (
          !token &&
          !popup &&
          !isLoginPage &&
          !isLoginOTP &&
          !mobileNo
        ) {
          setAuthStatus({ isLoading: false, isComplete: true, error: null });
        } else if (token) {
          await dispatch(
            signInMember({
              authToken: token,
            })
          );
          setAuthStatus({ isLoading: false, isComplete: true, error: null });
        } else {
          setAuthStatus({ isLoading: false, isComplete: true, error: null });
        }
      } catch (error) {
        console.error("Error during authentication:", error);
        setAuthStatus({
          isLoading: false,
          isComplete: false,
          error: error.message,
        });
      }
    };

    authenticateUser();
  }, []);

  return authStatus;
}

export default useAuthRedirect;
